export default __webpack_public_path__ + "static/media/mouse.757c1a38.svg";